import {
  DEFAULT_PAGE_SIZE_OPTIONS,
  type TablePreferencesConfig,
} from 'src/common/ui/TablePreferences';

import { STRING_GROUPS_PAGE_SIZE } from 'src/features/namespace/constants';
import type { TranslateFn } from 'src/i18n/shim/useTranslation';

/** Config for the string groups table; ids and order mirror `namespace/columns`. */

/** Every column the table can show, in default order. */
const columnOptions = (t: TranslateFn) =>
  [
    // alwaysVisible: this cell holds the only link into the group's detail page.
    { id: 'stringGroupId', label: t('sg-column-name'), alwaysVisible: true },
    { id: 'clientId', label: t('sg-column-client-id') },
    { id: 'teamName', label: t('sg-column-team-name') },
    { id: 'cxFamilyId', label: t('sg-column-cx-family') },
    { id: 'cxIds', label: t('sg-column-cx-ids') },
    { id: 'sourceLocale', label: t('sg-column-source-locale') },
    { id: 'stringCount', label: t('sg-column-string-count') },
    { id: 'createdAt', label: t('sg-column-created-on') },
    { id: 'updatedAt', label: t('sg-column-updated-on') },
  ] as const;

/**
 * `hideCxFamilyColumn` drops CX Family from the OPTIONS too, so the toggle is not
 * a dead control; storage is untouched, so a saved preference returns with it.
 * Memoise it — a fresh object re-creates the confirm handler.
 */
export function stringGroupsPreferencesConfig(
  t: TranslateFn,
  hideCxFamilyColumn: boolean,
): TablePreferencesConfig {
  const options = columnOptions(t);
  return {
    storageKey: 'LangHub-stringGroupsTablePreferences',
    columnOptions: hideCxFamilyColumn
      ? options.filter((option) => option.id !== 'cxFamilyId')
      : options,
    pageSizeOptions: DEFAULT_PAGE_SIZE_OPTIONS,
    defaultPageSize: STRING_GROUPS_PAGE_SIZE,
  };
}
